import React, { useEffect, useState } from 'react';
import SearchItems from './SearchPanels/SearchItems';
import { useLocation, useNavigate } from 'react-router-dom';

const Search = (props) => {
    const history = useNavigate();
    const location = useLocation();
    const [searchword, setSearchWord] = useState(location.state ?? '');
    const [result, setResult] = useState([]);
    const [keyword, setKeyword] = useState('');

    useEffect(() => {
        setSearchWord(location.state ?? '');
        if (location.state)
            doSearching(location.state);
    }, [location.state]);

    useEffect(() => {
        setResult([]);
    }, [keyword]);

    const searchText = (e) => {
        setSearchWord(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setKeyword(searchword)
            doSearching();
        }
    };

    const doSearching = (word) => {
        const searchKeyword = word ? word : searchword;
        setKeyword(searchKeyword);
        fetch(`api/Search/Searching?keyword=${searchKeyword}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                if (data.message === 'Success') {
                    setResult(data.data.table);
                }
            })
    };

    const executeSearch = (e) => {
        e.preventDefault();
        doSearching();
    };

    return (
        <div className="container contents-wrapper-bg">
            <div className="search-result">
                <div className="header">
                    <div className="headerWrap">
                        <div className="search-input">
                            <button className="btn-search" onClick={doSearching}><i className="icoKdc24 magnifier-b"></i></button>
                            <input type="text" placeholder="검색어를 입력하세요." onChange={e => searchText(e)} onKeyUp={e => handleKeyPress(e)} value={searchword} />
                            {/* value="setText" */}
                        </div>
                    </div>
                </div>
                <div className="result">
                    <SearchItems result={result} keyword={keyword} />
                </div>
            </div>
        </div>
    );
}
export default Search;